'use client';

import { useEffect, useState } from 'react';
import styles from '../auto-insurance-matches.module.scss';

interface ZipCodeInputProps {
  initialZipCode: string;
  onZipCodeChange: (zipCode: string) => void;
  onZipCodeValidChange: (isValid: boolean) => void;
}

const ZipCodeInput: React.FC<ZipCodeInputProps> = ({
  initialZipCode,
  onZipCodeChange,
  onZipCodeValidChange,
}) => {
  const [zipCode, setZipCode] = useState(initialZipCode);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (zipCode.length === 5) {
      setError(null);
      onZipCodeChange(zipCode);
      onZipCodeValidChange(true);
    } else if (zipCode.length > 0 && zipCode.length < 5) {
      onZipCodeValidChange(false);
      setError('Please enter a valid 5-digit US ZIP code');
    } else {
      setError(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zipCode]);

  return (
    <div className={styles.zipCodeContainer}>
      <span className={`${styles.zipCodeLabel} ${error ? styles.error : ''}`}>
        Zip Code
      </span>
      <input
        type="tel"
        value={zipCode}
        maxLength={5}
        onChange={(e) => setZipCode(e.target.value.replace(/\D/g, ''))}
        autoComplete="postal-code"
        className={`${styles.zipCodeInput} ${error ? styles.error : ''}`}
      />
      {error && <p className={styles.zipCodeError}>{error}</p>}
    </div>
  );
};

export default ZipCodeInput;
